import CalloutCard from '@stories/Components/Cards/CalloutCard/CalloutCard';
import * as React from 'react';
import S from './CalloutCards.styles';
const CalloutCards = (props) => {
    if (!props.items || props.items.length === 0) {
        return null;
    }
    let cols = 2;
    switch (props.items.length) {
        case 3:
        case 6:
        case 9:
            cols = 3;
            break;
        case 4:
        case 8:
        case 12:
            cols = 4;
            break;
        default:
            break;
    }
    return (React.createElement(S.Container, { id: props.anchorId, spacing: "padding", "data-variant": props.theme, "data-card-theme": props.cardTheme, "data-cols": cols },
        props.title && (React.createElement(S.TitleWrapper, { "data-split": props.content ? true : false },
            React.createElement(S.Title, { ...(props.titleType && props.titleType === 'h1' ? { as: 'h1' } : {}) }, props.title),
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }))),
        props.items.map((item, index) => (React.createElement(CalloutCard, { key: item.id, ...item, number: props.numbered ? index + 1 : undefined, translations: props.translations })))));
};
export default CalloutCards;
